// export const ApiAddress = "http://localhost:8000/api/";
// export const ApiAddress = "http://18.221.158.10:8003/api/";
// export const ApiAddress = "https://hardwarerepository.ctrlease.com/api/";
// export const ApiAddress = "http://18.117.228.151:8003/api/";
export const ApiAddress = "https://enterpriseapi.ctrlease.com/api/";
